document.addEventListener('DOMContentLoaded', function() {

    class DistributorSelector extends HTMLElement {
        constructor() {
            super();
            this.select = this.querySelector('select');
            this.entries = this.querySelectorAll('.c-distributor');
            this.selectValue = this.select.value;
            this.select.classList.remove('toggled');

            // Bind methods to preserve 'this' context
            this.handleChange = this.handleChange.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onClose = this.onClose.bind(this);
            this.onBlur = this.onBlur.bind(this);
        }

        connectedCallback() {
            this.select.addEventListener('change', this.handleChange);
            this.select.addEventListener('click', this.onClick);
            this.select.addEventListener('blur', this.onBlur);
            document.addEventListener('click', this.onClose);
        }

        onClick(event) {
            // Stop propagation so body click doesn't immediately close
            event.stopPropagation();
            this.select.classList.toggle('toggled');
        }

        onBlur() {
            // Remove toggled class when select loses focus (option selected or clicked away)
            this.select.classList.remove('toggled');
        }

        onClose(event) {
            // Only close if click is outside the select element
            if (!this.select.contains(event.target)) {
                this.select.classList.remove('toggled');
            }
        }

        handleChange(event) {
            const value = event.target.value;
            this.entries.forEach(entry => {
                if (entry.id === value) {
                    entry.style.display = 'block';
                } else {
                    entry.style.display = 'none';
                }
            });
            this.select.classList.remove('toggled');
        }

        disconnectedCallback() {
            this.select.removeEventListener('change', this.handleChange);
            this.select.removeEventListener('click', this.onClick);
            this.select.removeEventListener('blur', this.onBlur);
            document.removeEventListener('click', this.onClose);
        }
    }

    customElements.define('distributor-selector', DistributorSelector);
});